import React, { Component } from 'react';

import WhiteLogo from '../../assets/images/logo.png'
import BlackLogo from '../../assets/images/logo_footer.png';

class Header extends Component {
    render() {
        let classNames = 'header fixed-top';
        if (this.props.shrinked) {
            classNames += ' shrinked';
        }

        return (
            <header className={classNames}>
                <div className="container">
                    <nav className="navbar navbar-expand-md navbar-dark navbar">
                        <a className="navbar-brand" href="https://www.wewhodo.com">
                            <img src={this.props.shrinked ? BlackLogo : BlackLogo} alt="" />
                        </a>

                        {/*<button className="navbar-toggler" type="button" data-toggle="collapse"
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>*/}

                        {/*<div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item">
                                    <a className="nav-link" href="index.html">Home </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#.">How it works</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#.">Testimonial </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#."> Latest Events </a>
                                </li>
                            </ul>
                        </div>*/}

                        {/*<div className="login-area">
                            <ul className="navbar-nav mr-auto align-items-center">
                                <li className="nav-item">
                                    <a href="#." className="btn btn-outline-primary">Contact Us</a>
                                </li>
                            </ul>
                        </div>*/}
                    </nav>
                </div>
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js